import { useParams, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { Button } from '@/common/ui/button'
import { ArrowLeft } from 'lucide-react'
import { Card, CardContent } from '@/common/ui/card'
import ShopItemForm from '@/modules/shop/components/ShopItemForm'
import useQueryGetShopItem from '@/modules/shop/api/hooks/useQueryGetShopItem'

function EditShopItemPage() {
	const { id } = useParams<{ id: string }>()
	const navigate = useNavigate()

	const { data: shopItem, isLoading, error } = useQueryGetShopItem(id!)

	useEffect(() => {
		if (!id) {
			navigate('/operator/shop/items')
		}
	}, [id, navigate])

	useEffect(() => {
		if (error) {
			navigate('/operator/shop/items')
		}
	}, [error, navigate])

	const handleSuccess = () => {
		navigate('/operator/shop/items')
	}

	const handleBack = () => {
		navigate('/operator/shop/items')
	}

	if (!id) return null

	if (isLoading) {
		return (
			<PageContainer>
				<div className="mx-auto max-w-2xl">
					<div className="mb-6 flex items-center gap-4">
						<Button variant="outline" size="sm" onClick={handleBack}>
							<ArrowLeft className="mr-2 h-4 w-4" />
							กลับ
						</Button>
						<h1 className="text-2xl font-semibold">แก้ไขสินค้า</h1>
					</div>
					<Card>
						<CardContent className="p-6">
							<div className="flex h-32 items-center justify-center">
								<div className="text-muted-foreground">กำลังโหลด...</div>
							</div>
						</CardContent>
					</Card>
				</div>
			</PageContainer>
		)
	}

	return (
		<PageContainer>
			<div className="mx-auto max-w-2xl">
				<div className="mb-6 flex items-center gap-4">
					<Button variant="outline" size="sm" onClick={handleBack}>
						<ArrowLeft className="mr-2 h-4 w-4" />
						กลับ
					</Button>
					<h1 className="text-2xl font-semibold">แก้ไขสินค้า</h1>
				</div>
				<ShopItemForm
					mode="edit"
					itemId={id}
					initialData={shopItem}
					onSuccess={handleSuccess}
				/>
			</div>
		</PageContainer>
	)
}

export default withUserPermission(EditShopItemPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.MANAGE_SHOP],
})
